<section class="navigation">
  <div >
    <div class="brand">
      <!-- <a (click)="redirectAction()" id="logoclass">
        <img src="/assets/images/Logo1.svg" style="height: 40px;
        width: 112px;
        margin-top:5px;">
       </a>
       <a (click)="redirectAction()" id="logoclass">Health Slice</a> -->       
        <button mat-icon-button class="p-0">
          <img class="image-icon" alt="hslogo" height="50px" width="50px" src="assets/images/DEL_SEC_RGB.jpg" />
      </button>
      <!-- <span class="apptitle ml-2">Health Slice</span> -->
        <span> <img src="/assets/icons/HealthPerform_Logo.svg" alt=""  style="margin-left: 30px;" height="55px" width="180px" aria-label="processLogo" />
       </span>
    </div>
    <nav>
      <div class="nav-mobile">
        <!--<a id="nav-toggle" href="javascript:void(0);" (click)="toggle()">
        <span></span>
      </a>-->
      </div>
      <ul class="nav-list">
        <!--<li>
        <a href="#!">Home</a>
      </li>
      <li>
        <a href="#!">About</a>
      </li>
      <li>
        <a href="#!">Pricing</a>
      </li>
      <li>
        <a href="#!">Contact</a>
      </li>-->
      </ul>
    </nav>
    <app-logout *ngIf="userLoginStatus"></app-logout>

  </div>

</section>

